module.exports = __webpack_public_path__ + "static/img/science2.243ce2c5.png";